export const EDIT = "form/edit";
export const CHANGEMODE = "form/changeSubmitMode";
